import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useRemoveFinancingsFromCession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      cessionId,
      solfacilFinancingIds,
    }: {
      cessionId: number;
      solfacilFinancingIds: number[];
    }) => capitalMarketsService.removeFinancingsFromCession(cessionId, solfacilFinancingIds),
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Erro ao remover financiamentos da cessão';
      toast.error(errorMessage);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cession', 'detail'] });
      queryClient.invalidateQueries({ queryKey: ['cessions'] });
    },
  });
}
